import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError, ActivatedRoute, NavigationCancel, Params } from '@angular/router';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { Globals } from 'src/app/globals';

@Component({
    selector: 'kyc-redirect-error',
    templateUrl: './kyc-redirect-error.component.html',
    styleUrls: ['./kyc-redirect-error.component.css']
})
export class KycRedirectErrorComponent implements OnInit {
  
  errMsg: string = "";
  backURL: string = "";
  constructor(private route: ActivatedRoute, public router: Router,public globals: Globals) {}
        
  ngOnInit() {
    this.route.queryParams.subscribe(
      (params: Params) => {
        this.errMsg = params["errMsg"];
        this.backURL = params["returnURL"];
      }
    );
  }

  GoToBackPage() {
    let backURL = this.globals.KYC_UPLOAD_BACK_URL+"KYCRedirectError";
    if(this.backURL != '' && this.backURL != null && this.backURL != undefined) {
      backURL = this.backURL;
    }
    window.location.href = backURL;
  }
}